import { render, staticRenderFns } from "./HotelDescription.vue?vue&type=template&id=6f8ca6f8&"
import script from "./HotelDescription.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelDescription.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports